import { createApp } from 'vue'
import App from './App.vue'
import router from './js/router.js'
import store from './js/store/store.js'
import './assets/css/tailwind.css'
import PrimeVue from 'primevue/config'
import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import Tooltip from 'primevue/tooltip';

const app = createApp(App)

app.config.globalProperties.$salesforce = import.meta.env.VITE_HELPER_SALESFORCE_HOST
app.config.compilerOptions.whitespace = 'preserve'
// In order to use env salesforce url inside script tag since globalProperties $salesforce
// is only allowed in template.
app.provide('baseSalesforceURL', import.meta.env.VITE_HELPER_SALESFORCE_HOST)

app.use(store)
app.use(router)

import BaseLoadingIcon from '@/components/BaseLoadingIcon.vue'
app.component('BaseLoadingIcon', BaseLoadingIcon)


// vue-tippy
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
app.use(VueTippy, {
  component: 'tippy',
  defaultProps: {
    allowHTML: true,
    arrow: true
  },
})

// vue3-apexchart
import VueApexCharts from 'vue3-apexcharts'
app.use(VueApexCharts)

// vue-gtag-next
import VueGtag from 'vue-gtag-next'
app.use(VueGtag, {
  property: {
    id: import.meta.env.VITE_GOOGLE_ANALYTICS || 'G-HWEG080L6C' // Default to SE Helper - DEV
  }
})

app.directive('tooltip', Tooltip);

/**
 * Updating the Aura Preset to give some of our usuals.
 * Others will be styled on individual components.
*/
const MyPreset = definePreset(Aura, {
  semantic: {
    /**
     * Iris color taken from tailwind.config.js file.
    */
    primary: {
      100: '#e0e1ff',
      200: '#c6befe',
      300: '#ac98fd',
      400: '#9278fb',
      500: '#7855fa',
      600: '#6d40e6',
      700: '#612bd2',
      800: '#5615be',
      900: '#4b00aa'
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.700}',
          hoverColor: '{primary.600}'
        },
        surface: {
          100: '#f0f0f0',
          200: '#d7d7d7',
          300: '#bfbfbf',
          400: '#a6a6a6',
          500: '#8e8e8e',
          600: '#757575',
          700: '#5d5d5d',
          800: '#444444',
          850: '#333333',
          900: '#2c2c2c',
          950: '#1f1f1f',
          1000: '#131313'
        },
        // Defaults most text to our text-charcoal-800
        text: {
          color: '#444444'
        },
        formField: {
          // Defaults most text to our text-charcoal-800
          color: '#444444',
          // Defaults most text to our text-charcoal-700
          placeholderColor: '#5d5d5d',
          // Defaults background to bg-white
          background: '#FFFFFF'
        }
      },
      dark: {
        primary: {
          color: '{primary.600}',
          hoverColor: '{primary.700}',
        },
        surface: {
          100: '#f0f0f0',
          200: '#d7d7d7',
          300: '#bfbfbf',
          400: '#a6a6a6',
          500: '#8e8e8e',
          600: '#757575',
          700: '#5d5d5d',
          800: '#444444',
          850: '#333333',
          900: '#2c2c2c',
          950: '#1f1f1f',
          1000: '#131313'
        },
        // Defaults most text to our text-charcoal-200
        text: {
          color: '#d7d7d7'
        },
        formField: {
          // Defaults most text to our text-charcoal-200
          color: '#d7d7d7',
          // Defaults most text to our text-charcoal-400
          placeholderColor: '#a6a6a6',
          // Defaults background to bg-charcoal-900
          background: '#2c2c2c',
          // Default form field FloatLabel color
          floatLabel: {
            focus: {
              color: '#9278fb'
            }
          }
        }
      }
    }
  }
})

// PrimeVue
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: '.dark',
      prefix: 'primevue',
      cssLayer: {
        name: 'primevue',
        order: 'theme, base, primevue'
      }
    }
  }
})

router.isReady().then(() => {
  app.mount('#app')
})
